export default () => ({
    cartPopupIsOpen: false,
    // Names the addition in the dialog's accessible description, so entering it
    // announces what just happened rather than only "Your Cart".
    addedMessage: "",
    cart: {},
    removing: [],
    updating: [],

    filterLineItemId: "",

    init() {
        window.addEventListener("cartUpdate", (event) => {
            this.cart = event.detail;
        });
        window.addEventListener("addToCart", (event) => {
            // Find item by most recently updated date
            const lineItems = this.cart.lineItems
                .filter((a) => a.sku != this.cart.iceBrickSku)
                .filter((a) => event.detail.purchasableId == a.purchasableId);

            if (!lineItems.length) return;

            this.filterLineItemId = lineItems[0].id;
            this.addedMessage = `${lineItems[0].description} added to your cart.`;
            this.cartPopupIsOpen = true;

            // Deliberately no auto-dismiss. This dialog takes focus, so a timed
            // close is a WCAG 2.2.1 (Timing Adjustable) failure: it used to
            // vanish 5s after opening, throwing focus back to the trigger
            // mid-read and giving a screen reader user no chance to hear the
            // cart. It closes on Escape, the close button, or Continue Shopping.
        });
    },
});
